import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { fetchPropertyCounts, fetchPropertyById } from 'src/store/actions/properties';
import { setSearch } from 'src/store/actions/search';
import PropertyDevelopersTable from 'src/components/PropertyDevelopersTable/PropertyDevelopersTable';
import Loader from 'src/components/Loader';
import { PropertiesForContactsProvider } from 'src/pages/Contacts/ContactsContext/PropertiesForContactsContext';
import { ContactFormProvider } from 'src/SharedCommonContext/ContactFormContext';
import {
  useContactAPIOperationsProperties
} from 'src/pages/SharedPageCustomHooks/UseContactsSavePropertiesPage/useContactAPIOperationsProperties';

const PropertyDevelopersContent = ({ property }: any) => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthenticatedUser);

  const handleSetSearch = (searchData: any) => dispatch(setSearch(searchData));
  const onFetchPropertyCounts = (propertyId: any, userId: any, roleName: any) =>
    dispatch(fetchPropertyCounts(propertyId, userId, roleName));
  const onFetchPropertyById = (propertyId: any) =>
    dispatch(fetchPropertyById(propertyId));

  const {
    deletePropertyDeveloperFromProperty,
    isDeleting,
    fetchPropertyDevelopers,
    propertyDevelopers,
    isFetchingDevelopers,
  } = useContactAPIOperationsProperties();

  useEffect(() => {
    fetchPropertyDevelopers(property.propertyId);
  }, [property.propertyId]);

  const handleDeleteContactById = async (data: any) => {
    const result = await deletePropertyDeveloperFromProperty(
      data.id,
      property.propertyId
    );

    if (result.success) {
      onFetchPropertyById(property.propertyId);
      onFetchPropertyCounts(
        property.propertyId,
        user.id,
        user.roles[0].role.name
      );

      await fetchPropertyDevelopers(property.propertyId);
    }
  };

  const isLoading: boolean = isFetchingDevelopers || isDeleting;

  return isLoading ? (
    <Loader />
  ) : (
    <PropertyDevelopersTable
      onSearch={(e: any) =>
        handleSetSearch({ propertyDevelopers: e.target.value.trim() })
      }
      propertyDevelopers={propertyDevelopers}
      onDeleteContact={handleDeleteContactById}
      propertyData={property}
      onRefreshDevelopers={fetchPropertyDevelopers}
    />
  );
};

const PropertyDevelopers = ({ property }: any) => {
  return (
    <ContactFormProvider>
      <PropertiesForContactsProvider>
        <PropertyDevelopersContent property={property} />
      </PropertiesForContactsProvider>
    </ContactFormProvider>
  );
};

export default PropertyDevelopers;